export function generateColor(index: number): { background: string; border: string } {
  const hue = (index * 137.508) % 360;
  return {
    background: `hsla(${hue}, 70%, 60%, 0.5)`,
    border: `hsla(${hue}, 70%, 50%, 1)`,
  };
}
